module.exports = "/static/images/BCT-logo-horizontal.svg";